// components
import { Box } from '@mui/material';

// libs
import { capitalize } from 'lodash';

// types
import type { FC } from 'react';
import type { HeaderProps } from 'react-big-calendar';

// stores
import { useCalendarStore } from 'components/mrp/stores/calendarStore/calendarStore';

const CalendarColumnHeader: FC<HeaderProps> = ({ label }: HeaderProps) => {
  'use memo';
  const calendars = useCalendarStore((state) => state.calendars);

  const [weekdayFull, ...dateParts] = label.split(' ');
  const dayOfMonth = dateParts.join(' ');

  const weekday = capitalize(
    Object.keys(calendars).length < 3 ? weekdayFull : weekdayFull.slice(0, 2)
  );

  return (
    <>
      <Box>{weekday}</Box>
      <Box>{dayOfMonth}</Box>
    </>
  );
};

export default CalendarColumnHeader;
